import routerOptions0 from "/codebuild/output/src4167551800/src/codestar-connections.eu-west-1.amazonaws.com/git-http/471112859602/eu-west-1/ee15b64b-8c7d-4ab7-b668-2c0ec41dbd39/studyportals/OmniSearch/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/codebuild/output/src4167551800/src/codestar-connections.eu-west-1.amazonaws.com/git-http/471112859602/eu-west-1/ee15b64b-8c7d-4ab7-b668-2c0ec41dbd39/studyportals/OmniSearch/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}